import React, { lazy, Suspense } from "react";
import { Routes, Route, useSearchParams } from "react-router-dom";
import Credentials from "../pages/Credentials";
import LoginForEmail from "../pages/LoginForEmail";
import LoginError from "../pages/LoginError";
import { ProviderLoginError } from "../pages/ProviderLoginError";
// import Register from "../pages/Register";
const Login = lazy(() => import("../pages/Login"));
const Register = lazy(() => import("../pages/Register"));

const RoutesApp = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <Suspense fallback={<div></div>}>
      <Routes>
        <Route
          path="/"
          element={
            <Login
              code={searchParams.get("code")}
              username={searchParams.get("username")}
              urlRedirect={searchParams.get("urlRedirect")}
              appCode={searchParams.get("appCode")}
            />
          }
        />
        <Route
          path="/registration/acceptance"
          element={<Login codeInvite={searchParams.get("inviteId")} />}
        />
        <Route path="/autologin/email" element={<LoginForEmail />} />
        <Route path="/autologin/email/:user" element={<LoginForEmail />} />
        <Route
          path="/autologin/credentials/:uuid"
          element={
            <Credentials urlRedirect={searchParams.get("urlRedirect")} />
          }
        />
        <Route
          path="/error"
          element={
            <LoginError
              appCode={searchParams.get("appCode")}
              refError={searchParams.get("refError")}
            />
          }
        />
        <Route
          path="/provider-error"
          element={
            <ProviderLoginError
            providerError={searchParams.get("providerError")}
            />
          }
        />
        <Route
          path="/register"
          element={
            <Register
              code={searchParams.get("code")}
              username={searchParams.get("username")}
              urlRedirect={searchParams.get("urlRedirect")}
              appCode={searchParams.get("appCode")}
            />
          }
        />
      </Routes>
    </Suspense>
  );
};

export default RoutesApp;
